import gql from "graphql-tag";
import { useQuery as defaultUseQuery } from "@apollo/react-hooks";
import { ApolloInjection, QueryResult } from "@zapier/checkout/esm/types";

import { useCurrentAccountId } from "@zapier/checkout/esm/hooks";
import { currentPlanTiersQuery as CurrentPlanTiersQuery } from "@zapier/checkout/esm/graphql-types";

const currentPlanTiersQuery = gql`
  query currentPlanTiersQuery($accountId: Int!) {
    account(id: $accountId) {
      id
      currentPlan: planV2 {
        tiers {
          numTasks
          pricePerTask
        }
      }
    }
  }
`;

type Props = {
  skip?: boolean;
} & ApolloInjection;

export const useCurrentPlanTiers = ({
  skip,
  useQuery = defaultUseQuery,
}: Props = {}) => {
  const { accountId } = useCurrentAccountId({ skip, useQuery });

  const { data, error, loading }: QueryResult<CurrentPlanTiersQuery> = useQuery(
    currentPlanTiersQuery,
    {
      skip: skip || !accountId,
      variables: {
        accountId,
      },
    }
  );

  return {
    currentPlanTiers: data?.account?.currentPlan?.tiers ?? [],
    error: error ? "Error loading plan tier information." : undefined,
    isLoading: loading,
  };
};
